export enum DateRange {
    empty = "null", //null
    today = "0", // today
    yesterday = "1", //yesterday
    last7Days = "7", //last 7 days
    last28Days = "28", //last 28 days
    last3Months = "90", //last 3 months
}